class MobileProductStorySection {
  constructor() {
    if (!document.querySelector(".product-story-timeline")) return;

    const timelineFlickity = new Flickity(
      ".product-story-timeline.mobile-only",
      {
        draggable: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: false,
      },
    );

    const slidesFlickity = new Flickity(".product-story-slides.mobile-only", {
      draggable: true,
      pageDots: false,
      wrapAround: false,
      prevNextButtons: false,
    });

    const flickitys = [timelineFlickity, slidesFlickity];
    flickitys.forEach((flickity) => {
      flickity.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        flickitys.forEach((_flickity) => {
          _flickity.select(cellIndex);
        });
      });
      flickity.on("dragEnd", (index) => {
        const selectedIndex = flickity.selectedIndex;
        flickitys.forEach((_flickity) => {
          _flickity.select(selectedIndex);
        });
      });
    });

    try {
      const slidesArrowPrev = document.querySelector(
        ".product-story-slides-wrapper .flickity-prev",
      );
      const slidesArrowNext = document.querySelector(
        ".product-story-slides-wrapper .flickity-next",
      );

      slidesArrowPrev.addEventListener("click", () => {
        flickitys.forEach((_flickity) => {
          _flickity.previous();
        });
      });
      slidesArrowNext.addEventListener("click", () => {
        flickitys.forEach((_flickity) => {
          _flickity.next();
        });
      });
    } catch (error) {}
  }
}
if (typeof MobileProductStorySection !== "undefined") {
  new MobileProductStorySection();
}

class ProductStorySection {
  constructor() {
    if (!document.querySelector(".product-story-timeline")) return;

    const timelineFlickity = new Flickity(
      ".product-story-timeline.desktop-only",
      {
        draggable: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: false,
      },
    );

    const slidesFlickity = new Flickity(".product-story-slides.desktop-only", {
      draggable: true,
      pageDots: false,
      wrapAround: false,
      prevNextButtons: false,
    });

    const flickitys = [timelineFlickity, slidesFlickity];
    flickitys.forEach((flickity) => {
      flickity.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        flickitys.forEach((_flickity) => {
          _flickity.select(cellIndex);
        });
      });
      flickity.on("dragEnd", (index) => {
        const selectedIndex = flickity.selectedIndex;
        flickitys.forEach((_flickity) => {
          _flickity.select(selectedIndex);
        });
      });
    });

    try {
      const slidesArrowPrev = document.querySelector(
        ".product-story-slides-wrapper .flickity-prev",
      );
      const slidesArrowNext = document.querySelector(
        ".product-story-slides-wrapper .flickity-next",
      );

      slidesArrowPrev.addEventListener("click", () => {
        flickitys.forEach((_flickity) => {
          _flickity.previous();
        });
      });
      slidesArrowNext.addEventListener("click", () => {
        flickitys.forEach((_flickity) => {
          _flickity.next();
        });
      });
    } catch (error) {}
  }
}
if (typeof ProductStorySection !== "undefined") {
  new ProductStorySection();
}
